export default __webpack_public_path__ + "static/media/brand-7.8b4afa0e.png";